(function($, Swiper) {
  "use strict";

  initSwipers();

  function initSwipers() {
    /*
     Since swipers get added from ckeditor the
     initialization of swipers needs to be done dynamically
    */
    var thisSwiper = [];
    let $swipers = $(".swiper");
    $swipers.each(function(i) {
      let isBannerSwiper = $(this).hasClass("banner--swiper");
      $(this).prop("id", `swiper-${i}`);
      let $parent = $(this).parent();
      $parent.find(".swiper-button-next").prop("id", `swiper-${i}-next`);
      $parent.find(".swiper-button-prev").prop("id", `swiper-${i}-prev`);
      $parent.find(".swiper-pagination").prop("id", `swiper-${i}-pagination`);
      thisSwiper[i] = new Swiper(`#swiper-${i}`, {
        loop: true,
        init: true,
        effect: "fade",
        fadeEffect: { crossFade: true },
        centeredSlider: true,
        spaceBetween: 100,
        pagination: {
          el: `#swiper-${i}-pagination`
        },

        ...(isBannerSwiper && {
          autoplay: {
            delay: 5000,
            disableOnInteraction: false
          }
        }),

        navigation: {
          nextEl: `#swiper-${i}-next`,
          prevEl: `#swiper-${i}-prev`
        }
      });
    });
  }
})(jQuery, Swiper);
